import { Grid } from "@mui/material";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import useCurrentUser from "../../../hooks/useCurrentUser";
import AddComment from "./AddComment";
import History from "./History";
import {
  fetchTalentComments,
  selectAllTalentComments,
} from "./TalentCommentsSlice";

const Comments = () => {
  const { talentId } = useParams();
  const dispatch = useAppDispatch();
  const { user } = useCurrentUser();
  const comments = useAppSelector((state) => selectAllTalentComments(state));

  useEffect(() => {
    dispatch(fetchTalentComments({ talentId: talentId as string }));
  }, [talentId, dispatch]);

  return (
    <Grid container sx={{ paddingRight: "7px" }}>
      <Grid container sx={{ paddingLeft: "7px" }}>
        {user && (
          <AddComment
            authorId={user.id}
            firstName={user.firstName}
            lastName={user.lastName}
          />
        )}
      </Grid>
      <Grid container>
        <History
          comments={comments}
          currentUserId={user?.id ?? null}
        />
      </Grid>
    </Grid>
  );
};

export default Comments;
